import { styled } from 'styled-components';

export const AppLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.neutral50};
`;

export const Main = styled.main`
  flex: 1;
  width: 100%;
  min-width: 0;
`;

export const PageContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto 50px;
  padding: ${({ theme }) => theme.sizes['3xl']} ${({ theme }) => theme.sizes['5xl']};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.sizes.xl} ${({ theme }) => theme.sizes.lg};
    margin-bottom: ${({ theme }) => theme.sizes.xl};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.sizes.md} ${({ theme }) => theme.sizes.sm};
    margin-bottom: ${({ theme }) => theme.sizes.lg};
  }
`;
